<template>
  <v-dialog :value="value" persistent max-width="700">
    <d-comisaria :sede="sede" :fase="fase">
      <v-spacer />
      <v-btn color="secondary" @click="descargar">
        <v-icon dark>
          $download
        </v-icon>descargar
      </v-btn>
      <v-btn color="primary" @click="$emit('input', false)">
        cerrar
      </v-btn>
    </d-comisaria>
  </v-dialog>
</template>

<script>
import Comisaria from './Comisaria'

export default {
  components: {
    'd-comisaria': Comisaria,
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    sede: {
      type: Number,
      default: null
    },
    fase: {
      type: Number,
      default: null
    },
  },
  methods: {
    async descargar() {
      try {
        await this.$store.dispatch('session/ensureSession');
        const token = window.localStorage.getItem('token');
        const url = `${process.env.VUE_APP_SERVER_HOST}/api/archivos/info-carabineros?token=${token}&fspCodigo=${this.fase}&sedCodigo=${this.sede}`;
        window.location = url;
      } catch (err) {
        this.$store.commit('error-notification', err.message);
      }
      this.$emit('input', false)
    },
  }
};
</script>
